import { apiSlice, TAG_TYPES } from '../api/apiSlice';

export const shopVerificationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getShopVerification: builder.query({
      query: (shopId) => ({
        url: `/shop-verification/shop/${shopId}`,
      }),
      providesTags: (result, error, shopId) => [
        { type: TAG_TYPES.SHOP_VERIFICATION, id: shopId },
      ],
    }),

    uploadShopVerificationDocument: builder.mutation({
      query: (formData) => ({
        url: '/shop-verification/upload',
        method: 'POST',
        body: formData,
      }),
    }),

    submitShopVerification: builder.mutation({
      query: (data) => ({
        url: '/shop-verification/submit',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, { shopId }) => [
        { type: TAG_TYPES.SHOP_VERIFICATION, id: shopId },
        { type: TAG_TYPES.SHOP, id: shopId },
        TAG_TYPES.SHOP,
        TAG_TYPES.LEVEL_RANKING,
      ],
    }),
  }),
});

export const {
  useGetShopVerificationQuery,
  useUploadShopVerificationDocumentMutation,
  useSubmitShopVerificationMutation,
} = shopVerificationApiSlice;

export default shopVerificationApiSlice;

